import gql from 'graphql-tag'

export const fragments = {
	onlineProfile: gql`
		fragment profile on OnlineProfile {
			firstName
			lastName
			phoneNumber
		}
	`,
	customer: gql`
		fragment customer on Customer {
			id
			firstName
			lastName
			createdAt
			totalBookings
			phoneNumber
			email
			appointmentNotifications
			notes
			banned
		}
	`
}

export const customerOverviewQuery = gql`
	query customer($id: ID!) {
		customer(id: $id) {
			...customer
			profile {
				...profile
			}

			appointments(limit: 1000) {
				upcoming {
					id
					startTime
					status
					price
					duration
					services {
						id
						name
						price
						duration
					}
					employee {
						id
						firstName
						lastName
					}
				}
				past {
					id
					startTime
					status
					price
					duration
					services {
						id
						name
						price
						duration
					}
					employee {
						id
						firstName
						lastName
					}
				}
			}
		}
	}

	${fragments.customer}
	${fragments.onlineProfile}
`

export const customerQuery = gql`
	query customer($id: ID!) {
		customer(id: $id) {
			...customer
			profile {
				...profile
			}
		}
	}

	${fragments.customer}
	${fragments.onlineProfile}
`

export const customersQuery = gql`
	query customers($input: CustomerListInput!) {
		customers(input: $input) @connection(key: "paginatedCustomers") {
			...customer
			profile {
				...profile
			}
		}
	}

	${fragments.customer}
	${fragments.onlineProfile}
`

export const customerSearchQuery = gql`
	query SearchCustomers($input: CustomerSearchInput!) {
		searchCustomers(input: $input) {
			...customer
			profile {
				...profile
			}
		}
	}

	${fragments.customer}
	${fragments.onlineProfile}
`
